<template>
  <transition-group
    name="workbench-list"
    :tag="tag"
    class="workbench-motion-list"
    v-bind="$attrs"
    v-on="$listeners"
    @before-leave="disableItem"
    @before-enter="restoreItem"
    @leave-cancelled="restoreItem"
  ><slot /></transition-group>
</template>

<script>
export default {
  name: 'UiMotionList',
  inheritAttrs: false,
  props: { tag: { type: String, default: 'div' } },
  methods: {
    disableItem (element) {
      if (element.contains(document.activeElement)) document.activeElement.blur()
      element.setAttribute('inert', '')
    },
    restoreItem (element) { element.removeAttribute('inert') }
  }
}
</script>
